<template>
    <BasePanel
        headline="lang_LABEL_RELEASES"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="100"
            >
            <!-- Topslot -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :disabled="$route.params.alvId === 'new'"
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-release-title'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.tracks`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-tracks'"
                    >
                        {{ item.tracks }}
                    </div>
                </template>
                <template v-slot:[`item.displayArtist`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-display-artist'">
                        {{ item.displayArtist }}
                    </div>
                </template>
                <template v-slot:[`item.ean`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-ean'">
                        {{ item.ean }}
                    </div>
                </template>
                <template v-slot:[`item.catalogueNumber`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-catalogue-number'">
                        {{ item.catalogueNumber }}
                    </div>
                </template>
                <template v-slot:[`item.dateRetail`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-retail'">
                        {{ item.dateRetail !== null ? $d(new Date(item.dateRetail), 'alvDateFormat') : ''  }}
                    </div>
                </template>
                <template v-slot:[`item.dateDigital`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-digital'">
                        {{ item.dateDigital !== null ? $d(new Date(item.dateDigital), 'alvDateFormat') : ''  }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: 'LabelProjectsReleasesEditPanel',
    components: {
        BasePanel,
        BaseIcon,
        BaseButton
    },
    data() {
        return {
            alvqa: 'label-projects-edit-form-panel-releases'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_TRACKS'), 
                    value: 'tracks',
                    align: 'right', 
                    sortable: false,
                    width: "100px",
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST'), 
                    value: 'displayArtist',
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_EAN_UPC'), 
                    value: 'ean',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_CATALOGUE_NUMBER'), 
                    value: 'catalogueNumber', 
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL'), 
                    value: 'dateRetail', 
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'), 
                    value: 'dateDigital',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        listItems() { return this.$store.getters.getLabelProjectsReleases },
    },
    methods: {
        addNewRow(){
            this.$store.commit('setShowSearchDialog', true)
        },
        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit('setSelectedProjectsReleases', item)
            this.$store.commit('setDeletionDialogContext', 'SelectedProjectsReleases')
            this.$store.commit('setShowDeletionDialog', true)
        },
    }
}
</script>